export default function FormasPagamento() {
  return (
    <>
      <h1>Formas de Pagamento</h1>
    </>
  );
}
